<template>
  <div class="modal" v-if="seen">
    <div class="permanent" v-if="!done">
      <span>Moving <strong>{{ str_text(name) }}</strong> to <strong>{{ str_text(location) }}</strong></span>
      <span><img src="@/assets/30.gif" /></span>
    </div>
    <div class="loading" v-if="done">
      <p><span class="note"><strong style="font-weight:bold;">{{ movedfile }}</strong> moved to <strong
            style="font-weight:bold;">{{ destination }}</strong></span></p>
      <p><span class="btn cancel" @click="closebox">Ok</span> &nbsp;&nbsp; <span class="btn ok" @click="goto">Go to
          location </span></p>
    </div>
  </div>
</template>
<style scoped>
.permanent {
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24) !important;
  border-radius: 4px !important;
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.loading {
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24) !important;
  border-radius: 4px !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading p:last-child {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn {
  cursor: pointer;
  border-radius: 8px;
  width: 132px !important;
  height: 42px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.cancel {
  border: 1px solid #3F96D1 !important;
  color: #3F96D1 !important;
}

.ok {
  background-color: #3F96D1 !important;
  color: #fff !important;
}
</style>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      name: '',
      seen: false,
      index: null,
      loader: false,
      location: null,
      location_id: null,
      id: null,
      found: false,
      done: true,
      selected_folder_id: '',
      dir: [],
      movedfile: '',
      destination: '',
      destination_id: ''
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOTAL_USED_SPACE',
      'SET_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5)
        let sSeg = str.substr(str.length - 7, 7)

        return fSeg + '....' + sSeg
      }
      return str
    },
    load(index, id, location) {
      this.name = this.$store.getters.DIRECTORY_CHILDREN[index].dir
      this.seen = true
      this.location = location
      this.location_id = id
      this.index = index
      this.id = this.$store.getters.DIRECTORY_CHILDREN[index].id
      this.selected_folder_id = id

      let that = this

      let data = {
        token: cookies.getCookie('token'),
        move_file_id: this.id,
        selected_folder_id: this.selected_folder_id,
        ignore: false
      }

      this.$socket.emit('move_file', data, function (data) {
        if (data.message === 'completed') {
          that.done = true
          that.destination = data.destination
          that.movedfile = data.movedfile
          that.dir = data.dir
          that.selected_folder_id = data.dir.id
          that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)
          // let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          // that.UPDATE_TOTAL_USED_SPACE(total_space_used)
        }

        if (data.message === 'exist') {
          that.seen = false
          that.fileExist(data.new_name)
        }

        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    goto() {
      if (this.selected_folder_id) {
        this.loading = false
        this.wait = false

        let that = this

        let data = {
          db: this.dir.db,
          token: cookies.getCookie('token'),
          current_directory_id: this.selected_folder_id
        }

        this.$socket.emit('browse', data, function (data) {
          if (data.message === 'completed') {
            localStorage.setItem('current_directory_id', that.selected_folder_id)
            localStorage.setItem('current_directory', that.dir.name)
            localStorage.setItem('db', that.dir.db)
            that.SET_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_CURRENT_DIRECTORY(that.dir.name)
            that.SET_PATH(data.dir_path)
            that.SORT_DIRECTORY_CHILDREN()
            that.seen = false
          }

          if (data.data == false) {
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }
        })
      }
    },
    fileExist(new_name) {
      let id = this.$store.getters.DIRECTORY_CHILDREN[this.index].id
      this.$parent.file_exist(this.index, id, this.location_id, new_name, 'move')
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>
